<template>
    <div class="container" id="bla" style="height: calc(100% - 50px); width: 100%; max-width: 100%;">
        <!--
        Registruojam darba
        Siunciam PPA klientui emailu, jis su juo susipazista
        Atvyke duodam pasirasyti telefone,
        Kopija klientui, Justui
        Uzsidaro darbas sistemoje
        -->
            <div id="signature-pad" class="signature-pad" style="height: calc(100vh - 55px);">
                <div class="signature-pad--body">
                    <canvas></canvas>
                </div>
                <div class="signature-pad--footer">
                    <div class="description">Pasirašyti aukščiau</div>

                    <div class="btn-toolbar m-0 m-md-1 m-lg-3" role="toolbar">
                        <div class="btn-group mr-auto">
                            <button type="button" class="btn btn-outline-warning btn-sm text-dark" data-action="clear">Išvalyti</button>

                        </div>
                        <div class="btn-group mr-auto">
                            <button class="btn btn-outline-success btn-sm" data-action="tvirtinti">Tvirtinti parašą</button>
                        </div>
                        <div class="btn-group mr-0">
                            <button class="btn btn-outline-danger btn-sm" data-action="cancel">X</button>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
    window.SignaturePad = require('signature_pad/dist/signature_pad.umd.min');
    export default {
        name: "SignPad",
        mounted() {
            console.log('Component mounted.')

            var wrapper = document.getElementById("signature-pad");
            var clearButton = wrapper.querySelector("[data-action=clear]");
            var confirmButton = wrapper.querySelector("[data-action=tvirtinti]");
            var cancelButton = wrapper.querySelector("[data-action=cancel]");

            var canvas = wrapper.querySelector("canvas");

            var signaturePad = new SignaturePad(canvas, {
                // backgroundColor: 'rgba(255, 255, 255, 1)',
                backgroundColor: '#ffffff',
                penColor: 'rgb(25, 30, 160)'
            });

            function resizeCanvas() {
                // When zoomed out to less than 100%, for some very strange reason,
                // some browsers report devicePixelRatio as less than 1
                // and only part of the canvas is cleared then.
                var ratio =  Math.max(window.devicePixelRatio || 1, 1);
                // This part causes the canvas to be cleared
                canvas.width = canvas.offsetWidth * ratio;
                canvas.height = canvas.offsetHeight * ratio;
                canvas.getContext("2d").scale(ratio, ratio);
                // This library does not listen for canvas changes, so after the canvas is automatically
                // cleared by the browser, SignaturePad#isEmpty might still return false, even though the
                // canvas looks empty, because the internal data of this library wasn't cleared. To make sure
                // that the state of this library is consistent with visual state of the canvas, you
                // have to clear it manually.
                signaturePad.clear();
            }
            // On mobile devices it might make more sense to listen to orientation change,
            // rather than window resize events.
            window.onresize = resizeCanvas();
            // screen.orientation = window.location.reload();
            $(window).on("orientationchange", function( event ) {
                window.location.reload();
            });
            // resizeCanvas();


            var sign_started = false;

            canvas.addEventListener( 'touchstart', onTouchStart, false);
            function onTouchStart(e) {
                if(!sign_started){
                    // $('nav').hide();
                    // $('.alert').hide();
                    // var main = $('main');
                    // $.each(main.find("*"), function(i,v){
                    //     if($(v).hasClass('container') || $(v).hasClass('row') || $(v).hasClass('col-md-8')) {
                    //         $(v).css("width", "100%").css("height", "calc(100% - 50px)");
                    //     }
                    // });
                    $(document).scrollTop(100000);
                    // $('#signature-pad').css({height: "calc(100vh - 55px)"});
                    // main.removeClass('py-4').addClass('py-2');
                    // $('.container').css("max-width","100%");
                    // signaturePad.clear();
                    document.body.style.overflow = "hidden";
                    sign_started = true;
                    // resizeCanvas();
                    // signaturePad.clear();
                    // window.location.reload();
                }
            }
            cancelButton.addEventListener('click', function (event) {
                // signaturePad.clear();
                window.history.go(-1);
            });

            clearButton.addEventListener('click', function (event) {
                signaturePad.clear();
            });

            confirmButton.addEventListener("click", function (event) {
                if (signaturePad.isEmpty()) {
                    alert("Prieš tai trurite pasirašyti");
                } else {
                    // var dataURL = signaturePad.toDataURL('image/jpeg');
                    // document.getElementById('sign').setAttribute('src', signaturePad.toDataURL("image/jpeg"));
                    // window.location.href = "/"+signaturePad.toDataURL("image/jpeg");
                    var formData = {};
                    formData['sign'] = signaturePad.toDataURL('image/jpeg');
                    $.ajax({
                        type: 'POST',
                        // url: "",
                        url: window.location.href.replace('sign_', ''),
                        data: formData,
                        // dataType: 'json',
                        success: function (data) {
                            // console.log(data);
                            // gauname nuoroda i klienta
                            // alert('Success:');
                            window.location = data;
                            // return data;
                        },
                        error: function (data) {
                            // alert('Error:');
                            // document.getElementById('bla').innerHTML = JSON.stringify(data);
                            console.log('Error:', data);
                        }
                    });
                }
            });
        }
    }
</script>
<style>
    /**,*/
    /**::before,*/
    /**::after {*/
        /*box-sizing: border-box;*/
    /*}*/

    /*img {*/
        /*position: absolute;*/
        /*left: 0;*/
        /*top: 0;*/
    /*}*/

    .signature-pad {
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        font-size: 10px;
        width:100%;
        height:calc(100vh - 100px);
        max-width: 667px;
        max-height: 375px;
        background-color: #fff;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.27), 0 0 40px rgba(0, 0, 0, 0.08) inset;
        border-radius: 4px;
        padding: 8px;
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10 and IE 11 */
        user-select: none; /* Standard syntax */
    }

    .signature-pad--body {
        position: relative;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        border: 1px solid #f4f4f4;
    }

    .signature-pad--body
    canvas {
        border: 1px #1a202c solid;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border-radius: 4px;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.02) inset;
    }

    .signature-pad--footer {
        color: #C3C3C3;
        text-align: center;
        font-size: 1.2em;
        margin-top: 1px;
        margin-bottom: 3px;
    }


</style>
